var _rect, _path, _circle, _path2, _circle2, _path3, _circle3, _path4, _circle4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIntegrationHelpIcon = function SvgIntegrationHelpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 40,
    fill: "none",
    viewBox: "0 0 80 40"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51.302,
    height: 35,
    x: 26.138,
    y: 2.5,
    fill: "#fff",
    stroke: "#8C95A8",
    rx: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#8C95A8",
    d: "M25.647 8.009h51.267M43.081 8.009V37"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.249,
    cy: 14.509,
    r: 1.5,
    fill: "#ED4A7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8C95A8",
    strokeLinecap: "round",
    d: "M34.75 14.509h2.37"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.249,
    cy: 20.509,
    r: 1.5,
    fill: "#F4B400"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8C95A8",
    strokeLinecap: "round",
    d: "M34.75 20.509h2.37"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.249,
    cy: 26.509,
    r: 1.5,
    fill: "#12A4B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8C95A8",
    strokeLinecap: "round",
    d: "M34.75 26.509h2.37"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.249,
    cy: 32.509,
    r: 1.5,
    fill: "#945FCF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8C95A8",
    strokeLinecap: "round",
    d: "M34.75 32.509h2.37"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8C95A8",
    d: "M5.128 5h14.624v11.5h6.912M4.102 35.5h15.65V24h6.912M5.128 20H26.15"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#12A4B4",
    d: "m4.615 16 3.996 6.75H.618z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#945FCF",
    d: "M1.026 32h6.153v6H1.026z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4B400",
    d: "M0 4.164 4.27 0l4.27 4.164-4.27 4.163z"
  })));
};
export default SvgIntegrationHelpIcon;